import produce from 'immer';
import {
  AUTH_SIGN_IN_INIT,
  AUTH_SIGN_IN_SUCCESS,
  AUTH_SIGN_IN_FAILED,
  AUTH_SIGN_UP_SUCCESS,
  AUTH_SIGN_UP_FAILED,
  AUTH_SIGN_UP_INIT,
  AUTH_SIGN_OUT,
  UPDATE_USER_INIT,
  UPDATE_USER_SUCCESS,
  UPDATE_USER_FAILED,
  AUTH_VERIFY_EMAIL_SUCCESS,
  AUTH_VERIFY_EMAIL_INIT,
  AUTH_VERIFY_EMAIL_FAILED,
  ADMIN_START_IMPERSONATE,
  ADMIN_END_IMPERSONATE,
  AUTH_IMPERSONATE_INIT,
  AUTH_IMPERSONATE_FINISHED,
} from '../actionTypes';

const initialState = {
  isProceeding: false,
  isImpersonating: false,
  user: null,
  error: null,
};

const authReducer = (state = initialState, action) =>
  produce(state, (draft) => {
    switch (action.type) {
      case AUTH_SIGN_OUT:
        draft.user = null;
        localStorage.removeItem('authToken');
        break;
      case AUTH_SIGN_IN_INIT:
      case AUTH_SIGN_UP_INIT:
      case UPDATE_USER_INIT:
      case AUTH_VERIFY_EMAIL_INIT:
        draft.isProceeding = true;
        draft.error = null;
        break;
      case AUTH_SIGN_UP_SUCCESS:
      case UPDATE_USER_SUCCESS:
      case AUTH_SIGN_IN_SUCCESS:
        draft.user = action.user;
        draft.isProceeding = false;
        draft.error = null;
        break;
      case AUTH_VERIFY_EMAIL_SUCCESS:
        const cUser = draft.user && JSON.parse(JSON.stringify(draft.user));
        if (cUser) {
          cUser.verified = true;
        }
        draft.user = cUser;
        draft.isProceeding = false;
        draft.error = null;
        break;
      case AUTH_SIGN_UP_FAILED:
      case UPDATE_USER_FAILED:
      case AUTH_SIGN_IN_FAILED:
      case AUTH_VERIFY_EMAIL_FAILED:
        draft.error = action.error;
        draft.isProceeding = false;
        break;
      case AUTH_IMPERSONATE_INIT:
        draft.isImpersonating = true;
        break;
      case AUTH_IMPERSONATE_FINISHED:
        draft.isImpersonating = false;
        break;
      case ADMIN_END_IMPERSONATE:
        const adminInfo = localStorage.getItem('admin_impersonate');
        if (adminInfo) {
          draft.user = JSON.parse(adminInfo);
          localStorage.setItem('authToken', draft.user.token);
          localStorage.removeItem('admin_impersonate');
          window.location.href = '/';
        } else {
          draft.user = null;
          localStorage.removeItem('admin_impersonate');
          window.location.href = '/sign-in';
        }
        break;
      case ADMIN_START_IMPERSONATE:
        localStorage.setItem('admin_impersonate', JSON.stringify(draft.user));
        draft.user = null;
        localStorage.removeItem('authToken');
        break;
      default:
        break;
    }
  });

export default authReducer;
